import { render, staticRenderFns } from "./Col9.vue?vue&type=template&id=0da595ac&scoped=true"
import script from "./Col9.vue?vue&type=script&lang=js"
export * from "./Col9.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da595ac",
  null
  
)

export default component.exports